<div class="group-checkboxes">
    <div class="item-tnc">
        <span class="checkbox-wcag">
            <input
                class="checkbox-wcag__checkbox hidden"
                [checked]="_termsAgreed"
                type="checkbox"
                aria-hidden="true"
                attr.aria-required="true"
                required
                tabindex="-1"
                attr.aria-label="{{ 'READ_TERMS_CHECKBOX_ARIA_LABEL' | translate }} {{ 'ASTERISK' | translate }}" />

            <span
                class="checkbox-wcag__checkmark"
                [attr.aria-checked]="_termsAgreed"
                (click)="toggleTermsAgreed($event)"
                (keydown.space)="toggleTermsAgreed($event)"
                tabindex="0"
                role="checkbox"
                attr.aria-required="true"
                attr.aria-label="{{ 'READ_TERMS_CHECKBOX_ARIA_LABEL' | translate }} {{ 'ASTERISK' | translate }}">
            </span>

            <label class="checkbox-wcag__label checkbox-wcag__label--large-offset">
                <span>
                    <span
                        class="link-label"
                        (click)="toggleTermsAgreed($event)"
                        (keydown.enter)="toggleTermsAgreed($event)"
                        (keydown.space)="toggleTermsAgreed($event)">
                        {{ labelText | translate }}
                    </span>

                    <a
                        class="link link--emphasized link--action"
                        #modalTrigger
                        *ngIf="showTermsLink"
                        (click)="onShowTermsModalClick()"
                        (keydown.enter)="onShowTermsModalClick()"
                        (keydown.space)="onShowTermsModalClick()"
                        tabindex="0">
                        {{ 'WITH_TERMS_AND_CONDITIONS' | translate }}
                    </a>
                </span>
            </label>
        </span>
    </div>
</div>

<ridango-modal [size]="'800'" [visible]="showModal" [isItSmall]="false" (onCloseModal)="onCloseModalClick()">
    <ridango-terms-modal-content [termsUrl]="termsUrl" (onAgree)="onAgreeModalClick($event)">
    </ridango-terms-modal-content>
</ridango-modal>
